import React from 'react';
import { HTMLMotionProps } from 'framer-motion';
import { PageTitleElement } from './style';

export default function PageTitle(props: HTMLMotionProps<'h1'>): JSX.Element {
  return <PageTitleElement>{props.children}</PageTitleElement>;
}
